<li class="dropdown top-menu-item-xs visible-sm visible-xs">
	<a id="ct-open-searchbar" href="#mobile-search-bar" data-toggle="collapse">
		<i class="fa fa-search"></i>
	</a>
</li>
<li id="h-profile" class="dropdown top-menu-item-xs">
	<a aria-expanded="true" data-toggle="dropdown" class="dropdown-toggle profile" href="">
		<i id="ct-user-menu" class="fa fa-user"></i><span class="caret"></span>
	</a>
	<ul id="js-main-menu" class="dropdown-menu multi-level">
		<li class="notifi-title m-b-10">
			{{name}}
		</li>
		<li>
			<a href="#alarm-list">
				<i class="fa fa-bell m-r-5"></i> {{TR "Alarme"}} <span class="label label-danger js-alarm-count-badge"></span>
			</a>
		</li>
		<li>
			<div class="divider"></div>
		</li>
		{{>STATUS_MENU_ENTRY status=status}}
		<li>
			<div class="divider"></div>
		</li>
		{{>PROFILE_MENU_ENTRY profile=profile}}
	</ul>
</li>
